import { render, staticRenderFns } from "./BookingEdit.vue?vue&type=template&id=34227e22"
import script from "./BookingEdit.vue?vue&type=script&lang=js"
export * from "./BookingEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports